/* Skoon GWP: face_cream:gwp trigger -> 1x cleanser:gwp gift PER trigger unit.
   Mix allowed: earned gifts can be different cleanser variants.
   The automatic Buy Y Get X discount handles the price; the theme only
   Adds/removes gift lines (marked with properties._skoon_gwp).
   Each gift line carries _gwp_for_product / _gwp_for_variant pointing at the
   trigger unit it was added for, so removing a trigger removes ITS gifts:
   - earned(pid) = trigger qty of trigger product pid (non-gift lines)
   - gifts linked to pid are trimmed when pid's triggers drop
   - legacy gifts without a link are attributed oldest-need-first
   Coexists with GiftBox sync (ignores ghost lines, own header). */
(function () {
  var ROOT = '/';
  try {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      ROOT = window.Shopify.routes.root;
      if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';
    }
  } catch (e) {}

  var HEADER = 'X-Skoon-Gwp';
  var state = {
    triggerTag: 'face_cream:gwp',
    giftTag: 'cleanser:gwp',
    markerKey: '_skoon_gwp',
    markerValue: 'cleanser_gwp',
    triggerProductIds: {},
    variantToProduct: {},
    giftOptions: [],
    catalogLoaded: false,
    catalogFailed: false,
    syncing: false,
    modalOpen: false,
    justAddedTrigger: false,
    pendingAddedVariants: [],
    unpairedUnits: [],
    triggerUnits: [],
    evalTimer: 0,
    ctaBound: false,
    earned: 0,
    giftTotal: 0,
    dismissed: false,
    owedAtDismiss: 0,
    drawerOpenedAt: 0,
    prevOverflow: ''
  };

  function $(sel, root) { return (root || document).querySelector(sel); }
  function money(amount) {
    try {
      // products.json prices are major-unit decimal strings ("499.95"),
      // not cents — parse directly instead of dividing by 100.
      var n = parseFloat(amount);
      if (isNaN(n)) return '';
      var code = '';
      try { code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || ''; } catch (e) {}
      var symbols = { ZAR: 'R ', USD: '$', EUR: '€', GBP: '£' };
      var sym = symbols[code] || (code ? code + ' ' : '');
      return sym + n.toFixed(2);
    } catch (e) { return ''; }
  }

  function readConfig() {
    var el = $('#skoon-gwp');
    if (!el || !el.dataset) return;
    if (el.dataset.triggerTag) state.triggerTag = el.dataset.triggerTag;
    if (el.dataset.giftTag) state.giftTag = el.dataset.giftTag;
    if (el.dataset.giftMarker) state.markerKey = el.dataset.giftMarker;
    if (el.dataset.giftMarkerValue) state.markerValue = el.dataset.giftMarkerValue;
  }

  function isOurRequest(input, init) {
    try {
      var h = new Headers((init && init.headers) || (input && input.headers) || undefined);
      return h.get(HEADER) === '1';
    } catch (e) { return false; }
  }

  function gwpFetch(url, options) {
    options = options || {};
    options.credentials = options.credentials || 'same-origin';
    options.headers = options.headers || {};
    options.headers[HEADER] = '1';
    return fetch(url, options);
  }

  function getCart() {
    return gwpFetch(ROOT + 'cart.js?gwp=' + Date.now(), {
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    });
  }

  /* Catalog: one /collections/all/products.json sweep (up to 4 pages),
     filter by tag. products.json exposes tags, variants, images. */
  function fetchCatalogPage(page) {
    var url = ROOT + 'collections/all/products.json?limit=250&page=' + page;
    return gwpFetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('catalog');
      return r.json();
    }).then(function (data) {
      return (data && data.products) || [];
    }).catch(function () { return []; });
  }

  function pickGiftVariant(product) {
    var variants = product.variants || [];
    if (!variants.length) return null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available !== false) return variants[i];
    }
    return variants[0];
  }

  function productImage(product) {
    if (product.images && product.images.length && product.images[0].src) return product.images[0].src;
    return '';
  }

  function hasTag(product, tag) {
    var tags = product.tags || [];
    for (var i = 0; i < tags.length; i++) {
      if (tags[i] === tag) return true;
    }
    return false;
  }

  function loadCatalog() {
    if (state.catalogLoaded || state.catalogFailed) return Promise.resolve();
    var pages = [fetchCatalogPage(1), fetchCatalogPage(2), fetchCatalogPage(3), fetchCatalogPage(4)];
    return Promise.all(pages).then(function (results) {
      var all = [];
      results.forEach(function (list) { all = all.concat(list); });
      // Dedupe by id (pages beyond range repeat page 1 on some stores).
      var seen = {};
      var products = [];
      all.forEach(function (p) {
        if (!p || seen[p.id]) return;
        seen[p.id] = true;
        products.push(p);
      });
      state.triggerProductIds = {};
      state.variantToProduct = {};
      state.giftOptions = [];
      products.forEach(function (p) {
        if (hasTag(p, state.triggerTag)) {
          state.triggerProductIds[String(p.id)] = true;
          (p.variants || []).forEach(function (v) {
            if (v && v.id != null) state.variantToProduct[String(v.id)] = String(p.id);
          });
        }
        if (hasTag(p, state.giftTag)) {
          var v = pickGiftVariant(p);
          if (!v) return;
          state.giftOptions.push({
            product_id: p.id,
            variant_id: v.id,
            title: p.title,
            handle: p.handle,
            image: productImage(p),
            price: v.price
          });
        }
      });
      state.catalogLoaded = true;
    }).catch(function () {
      state.catalogFailed = true;
    });
  }

  function isGhost(item) {
    return item && item.product_type === 'giftbox_ghost_product';
  }

  function isGiftLine(item) {
    if (!item || isGhost(item)) return false;
    var props = item.properties || {};
    return props[state.markerKey] === state.markerValue;
  }

  function isTriggerLine(item) {
    if (!item || isGhost(item) || isGiftLine(item)) return false;
    return !!state.triggerProductIds[String(item.product_id)];
  }

  function giftPoolIds() {
    var ids = {};
    state.giftOptions.forEach(function (g) { ids[String(g.variant_id)] = true; });
    return ids;
  }

  var LINK_PRODUCT_KEY = '_gwp_for_product';
  var LINK_VARIANT_KEY = '_gwp_for_variant';

  function linkOf(item) {
    var props = (item && item.properties) || {};
    return {
      forProduct: String(props[LINK_PRODUCT_KEY] || ''),
      forVariant: String(props[LINK_VARIANT_KEY] || '')
    };
  }

  function evaluate(opts) {
    opts = opts || {};
    if (state.syncing) return Promise.resolve();
    if (!state.catalogLoaded) {
      if (state.catalogFailed) return Promise.resolve();
      return loadCatalog().then(function () { return evaluate(opts); });
    }
    state.syncing = true;
    return getCart().then(function (cart) {
      return reconcileCart(cart, opts, 0);
    }).catch(function () {}).then(function () {
      state.syncing = false;
    });
  }

  function reconcileCart(cart, opts, depth) {
    opts = opts || {};
    var items = (cart && cart.items) || [];
    var pool = giftPoolIds();
    // Triggers grouped per product (cart order kept for attribution).
    var perProduct = {};
    var triggerOrder = [];
    var triggerQty = 0;
    var giftLines = []; // {line, variant_id, quantity, forProduct, forVariant}
    items.forEach(function (item, idx) {
      if (isTriggerLine(item)) {
        var pid = String(item.product_id);
        var vid = String(item.variant_id);
        triggerQty += item.quantity || 0;
        if (!perProduct[pid]) {
          perProduct[pid] = { qty: 0, variants: {}, lastVariant: vid };
          triggerOrder.push(pid);
        }
        perProduct[pid].qty += item.quantity || 0;
        perProduct[pid].variants[vid] = (perProduct[pid].variants[vid] || 0) + (item.quantity || 0);
        perProduct[pid].lastVariant = vid;
      } else if (isGiftLine(item)) {
        var link = linkOf(item);
        giftLines.push({
          line: idx + 1,
          variant_id: item.variant_id,
          quantity: item.quantity || 0,
          forProduct: link.forProduct,
          forVariant: link.forVariant
        });
      }
    });

    // No triggers: drop every managed gift line.
    if (triggerQty === 0) {
      resetPairing();
      if (giftLines.length > 0) {
        return removeGiftLines(giftLines).then(function () {
          state.earned = 0;
          state.giftTotal = 0;
          state.justAddedTrigger = false;
          ensureCta(0, 0);
          if (state.modalOpen) closeModal(false);
        });
      }
      state.justAddedTrigger = false;
      ensureCta(0, 0);
      return Promise.resolve();
    }

    // Drop gift lines whose variant left the pool, then reconcile fresh
    // (line indices shift after removals).
    var unknown = giftLines.filter(function (g) { return !pool[String(g.variant_id)]; });
    if (unknown.length > 0 && depth < 2) {
      return removeGiftLines(unknown).then(function () {
        return getCart().then(function (cart2) {
          return reconcileCart(cart2, opts, depth + 1);
        });
      });
    }

    var known = giftLines.filter(function (g) { return pool[String(g.variant_id)]; });
    var ops = [];

    // 1) Gifts linked to a trigger product: trim newest first down to what
    //    that product still earns (0 when the product is gone -> its gifts go).
    var keptLinked = {};
    var linkedGroups = {};
    known.forEach(function (g) {
      if (!g.forProduct) return;
      (linkedGroups[g.forProduct] = linkedGroups[g.forProduct] || []).push(g);
    });
    Object.keys(linkedGroups).forEach(function (fp) {
      var group = linkedGroups[fp].slice().sort(function (a, b) { return a.line - b.line; });
      var target = perProduct[fp] ? perProduct[fp].qty : 0;
      var kept = trimPlan(group, target, ops);
      keptLinked[fp] = kept;
    });

    // 2) Legacy gifts without a link: attribute oldest-first to outstanding
    //    product needs; trim newest leftovers beyond every need.
    var unlinked = known.filter(function (g) { return !g.forProduct; })
      .sort(function (a, b) { return a.line - b.line; });
    var needTotal = 0;
    triggerOrder.forEach(function (pid) {
      needTotal += Math.max(0, perProduct[pid].qty - (keptLinked[pid] || 0));
    });
    var unlinkedTotal = 0;
    unlinked.forEach(function (g) { unlinkedTotal += g.quantity; });
    var keptUnlinked = unlinkedTotal;
    if (unlinkedTotal > needTotal) {
      keptUnlinked = trimPlan(unlinked.slice(), needTotal, ops);
    }

    var keptTotal = 0;
    Object.keys(keptLinked).forEach(function (fp) { keptTotal += keptLinked[fp]; });
    keptTotal += keptUnlinked;

    if (ops.length > 0) {
      return applyOps(ops).then(function () {
        settleState(triggerQty, keptTotal, perProduct, keptLinkedWithUnlinked(perProduct, keptLinked, triggerOrder, keptUnlinked), triggerOrder, opts);
      });
    }
    settleState(triggerQty, keptTotal, perProduct, keptLinkedWithUnlinked(perProduct, keptLinked, triggerOrder, keptUnlinked), triggerOrder, opts);
    return Promise.resolve();
  }

  // Plans newest-first reductions of one line group down to target total,
  // pushing {line, quantity} ops. Returns the kept total.
  function trimPlan(groupOldestFirst, target, ops) {
    var total = 0;
    groupOldestFirst.forEach(function (g) { total += g.quantity; });
    var over = total - target;
    for (var i = groupOldestFirst.length - 1; i >= 0 && over > 0; i--) {
      var g = groupOldestFirst[i];
      if (g.quantity <= over) {
        ops.push({ line: g.line, quantity: 0 });
        over -= g.quantity;
        total -= g.quantity;
      } else {
        ops.push({ line: g.line, quantity: g.quantity - over });
        total -= over;
        over = 0;
      }
    }
    return total;
  }

  // Applies line updates in descending line order (safe: removing a higher
  // line never shifts a lower line's index; reductions shift nothing).
  // Requests the drawer section so the drawer repaints immediately instead
  // of leaving the removed gift visible until the next theme refresh.
  function applyOps(ops) {
    var sorted = ops.slice().sort(function (a, b) { return b.line - a.line; });
    var chain = Promise.resolve();
    var lastResp = null;
    sorted.forEach(function (op) {
      chain = chain.then(function () {
        return gwpFetch(ROOT + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: op.line,
            quantity: op.quantity,
            sections: ['cart-drawer'],
            sections_url: window.location.pathname
          })
        }).then(function (r) { return r.ok ? r.json() : null; }).then(function (data) {
          if (data) lastResp = data;
        }).catch(function () {});
      });
    });
    return chain.then(function () {
      if (lastResp) paintDrawerFromAdd(lastResp);
      emitCartUpdate();
    });
  }

  // Folds attributed legacy gifts into keptLinked so needs/unpaired units
  // come out right without rewriting old lines' properties.
  function keptLinkedWithUnlinked(perProduct, keptLinked, triggerOrder, keptUnlinked) {
    var merged = {};
    Object.keys(keptLinked).forEach(function (fp) { merged[fp] = keptLinked[fp]; });
    var remaining = keptUnlinked;
    triggerOrder.forEach(function (pid) {
      if (remaining <= 0) return;
      var need = Math.max(0, perProduct[pid].qty - (merged[pid] || 0));
      var take = Math.min(need, remaining);
      merged[pid] = (merged[pid] || 0) + take;
      remaining -= take;
    });
    return merged;
  }

  function settleState(earned, keptTotal, perProduct, keptByProduct, triggerOrder, opts) {
    opts = opts || {};
    state.earned = earned;
    state.giftTotal = keptTotal;
    rebuildPairing(perProduct, keptByProduct, triggerOrder);
    ensureCta(earned, keptTotal);
    updateProgress();
    var owed = earned - keptTotal;
    if (owed > 0) {
      // Newly owed gifts lift any earlier manual dismiss.
      if (owed > state.owedAtDismiss) state.dismissed = false;
      if (state.giftOptions.length && shouldAutoOpen(owed, opts)) {
        openModal();
      }
    } else {
      if (state.modalOpen) closeModal(false);
      state.dismissed = false;
      state.owedAtDismiss = 0;
    }
    state.justAddedTrigger = false;
    state.pendingAddedVariants = [];
  }

  function drawerIsOpen() {
    try {
      if (document.querySelector('m-cart-drawer.m-cart-drawer--active')) return true;
      if (Date.now() - (state.drawerOpenedAt || 0) < 3000) return true;
    } catch (e) {}
    return false;
  }

  // Drawer open + owed gifts => open the popup on its own (no CTA click
  // needed). On the cart page there is no drawer, so the CTA button there
  // remains the entry point. A manual dismiss suppresses re-pops until
  // something new is owed.
  function shouldAutoOpen(owed, opts) {
    if (state.dismissed && owed <= state.owedAtDismiss) return false;
    if (state.modalOpen) return true;
    if (drawerIsOpen()) return true;
    if (state.justAddedTrigger || (opts && opts.autoprompt)) return true;
    return false;
  }

  function resetPairing() {
    state.unpairedUnits = [];
    state.triggerUnits = [];
    state.pendingAddedVariants = [];
  }

  // Builds the pick-order for the popup: most-recently-added trigger
  // product first, then remaining needs in cart order.
  function rebuildPairing(perProduct, keptByProduct, triggerOrder) {
    var needs = {};
    triggerOrder.forEach(function (pid) {
      needs[pid] = Math.max(0, perProduct[pid].qty - (keptByProduct[pid] || 0));
    });
    state.triggerUnits = [];
    triggerOrder.forEach(function (pid) {
      var qty = perProduct[pid].qty;
      for (var i = 0; i < qty && i < 99; i++) {
        state.triggerUnits.push({ product_id: pid, variant_id: perProduct[pid].lastVariant });
      }
    });
    state.unpairedUnits = [];
    var recentPids = [];
    (state.pendingAddedVariants || []).forEach(function (vid) {
      var pid = state.variantToProduct[String(vid)];
      if (pid && needs[pid] > 0 && recentPids.indexOf(pid) === -1) recentPids.push(pid);
    });
    recentPids.forEach(function (pid) {
      pushUnits(pid, needs[pid], perProduct[pid].lastVariant);
      needs[pid] = 0;
    });
    triggerOrder.forEach(function (pid) {
      if (needs[pid] > 0) {
        pushUnits(pid, needs[pid], perProduct[pid].lastVariant);
        needs[pid] = 0;
      }
    });
  }

  function pushUnits(pid, count, vid) {
    for (var i = 0; i < count && i < 99; i++) {
      state.unpairedUnits.push({ product_id: pid, variant_id: vid });
    }
  }

  function removeGiftLines(lines) {
    // Remove from highest line index down so indices stay valid.
    // Includes the drawer section so the drawer repaints at once.
    var sorted = lines.slice().sort(function (a, b) { return b.line - a.line; });
    var chain = Promise.resolve();
    var lastResp = null;
    sorted.forEach(function (g) {
      chain = chain.then(function () {
        return gwpFetch(ROOT + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: g.line,
            quantity: 0,
            sections: ['cart-drawer'],
            sections_url: window.location.pathname
          })
        }).then(function (r) { return r.ok ? r.json() : null; }).then(function (data) {
          if (data) lastResp = data;
        }).catch(function () {});
      });
    });
    return chain.then(function () {
      if (lastResp) paintDrawerFromAdd(lastResp);
      emitCartUpdate();
    });
  }

  /* ---- Modal (pick N gifts, mix allowed: one tap = +1 unit) ---- */
  function modalEl() { return $('#skoon-gwp'); }
  function gridEl() { return $('#skoon-gwp-grid'); }
  function progressEl() { return $('#skoon-gwp-progress'); }

  function updateProgress() {
    var el = progressEl();
    if (!el) return;
    if (!state.earned) { el.textContent = ''; return; }
    var have = Math.min(state.giftTotal, state.earned);
    if (have >= state.earned) el.textContent = 'All ' + state.earned + ' FREE gift' + (state.earned === 1 ? '' : 's') + ' added.';
    else if (have === 0) el.textContent = 'Pick ' + state.earned + ' FREE cleanser' + (state.earned === 1 ? '' : 's') + ' — one for every face cream.';
    else el.textContent = 'Added ' + have + ' of ' + state.earned + ' — pick ' + (state.earned - have) + ' more.';
  }

  function renderGifts() {
    var grid = gridEl();
    if (!grid) return;
    grid.innerHTML = '';
    if (!state.giftOptions.length) {
      var p = document.createElement('p');
      p.className = 'skoon-gwp__empty';
      p.textContent = 'No gifts available right now.';
      grid.appendChild(p);
      return;
    }
    state.giftOptions.forEach(function (g) {
      var card = document.createElement('div');
      card.className = 'skoon-gwp__card';

      if (g.image) {
        var img = document.createElement('img');
        img.src = g.image;
        img.alt = g.title;
        img.loading = 'lazy';
        card.appendChild(img);
      }
      var name = document.createElement('p');
      name.className = 'skoon-gwp__name';
      name.textContent = g.title;
      card.appendChild(name);

      var price = document.createElement('p');
      price.className = 'skoon-gwp__price';
      var was = document.createElement('s');
      was.textContent = money(g.price);
      price.appendChild(was);
      var free = document.createElement('span');
      free.className = 'skoon-gwp__free';
      free.textContent = 'FREE';
      price.appendChild(free);
      card.appendChild(price);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'skoon-gwp__choose';
      btn.textContent = 'Choose this gift';
      btn.setAttribute('data-variant-id', String(g.variant_id));
      btn.addEventListener('click', function () { addGift(g); });
      card.appendChild(btn);

      grid.appendChild(card);
    });
  }

  function openModal() {
    var modal = modalEl();
    if (!modal || state.modalOpen) { updateProgress(); return; }
    if (!state.giftOptions.length) return;
    renderGifts();
    updateProgress();
    modal.hidden = false;
    state.modalOpen = true;
    lockScroll();
    var close = modal.querySelector('.skoon-gwp__close');
    if (close && close.focus) { try { close.focus(); } catch (e) {} }
  }

  function lockScroll() {
    try {
      state.prevOverflow = document.body.style.overflow || '';
      document.body.style.overflow = 'hidden';
    } catch (e) {}
  }

  function unlockScroll() {
    // The drawer never touches body overflow (verified live), so our popup
    // owns this lock: always release it on close, restoring whatever was
    // there before. Deferring to the drawer left pages permanently frozen.
    try {
      document.body.style.overflow = state.prevOverflow || '';
    } catch (e) {}
    state.prevOverflow = '';
  }

  function closeModal(manual) {
    var modal = modalEl();
    if (!modal || !state.modalOpen) return;
    if (manual) {
      // Shopper closed it themselves: don't pop it back up until something
      // new is owed. The CTA button stays as the way back in.
      state.dismissed = true;
      state.owedAtDismiss = Math.max(0, state.earned - state.giftTotal);
    } else {
      state.dismissed = false;
      state.owedAtDismiss = 0;
    }
    modal.hidden = true;
    state.modalOpen = false;
    unlockScroll();
  }

  function addGift(g) {
    var grid = gridEl();
    if (grid) {
      grid.querySelectorAll('.skoon-gwp__choose').forEach(function (b) { b.disabled = true; });
    }
    // Pair this gift with one outstanding trigger unit (most recent first).
    var unit = null;
    if (state.unpairedUnits.length) unit = state.unpairedUnits.shift();
    else if (state.triggerUnits.length) unit = state.triggerUnits[state.triggerUnits.length - 1];
    var props = {};
    props[state.markerKey] = state.markerValue;
    props._gwp_trigger = state.triggerTag;
    props[LINK_PRODUCT_KEY] = unit ? String(unit.product_id) : '';
    props[LINK_VARIANT_KEY] = unit ? String(unit.variant_id) : '';
    return gwpFetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: g.variant_id, quantity: 1, properties: props }],
        sections: ['cart-drawer'],
        sections_url: window.location.pathname
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('add gift failed');
      return r.json();
    }).then(function (resp) {
      state.giftTotal += 1;
      updateProgress();
      paintDrawerFromAdd(resp);
      emitCartUpdate();
      if (state.giftTotal >= state.earned) {
        closeModal(false);
        ensureCta(state.earned, state.giftTotal);
      } else if (grid) {
        grid.querySelectorAll('.skoon-gwp__choose').forEach(function (b) { b.disabled = false; });
      }
      scheduleEvaluate({});
    }).catch(function () {
      if (grid) {
        grid.querySelectorAll('.skoon-gwp__choose').forEach(function (b) { b.disabled = false; });
      }
    });
  }

  function paintDrawerFromAdd(resp) {
    try {
      var d = document.querySelector('m-cart-drawer');
      if (d && resp && resp.sections && typeof d.renderContents === 'function') {
        d.renderContents(resp);
      }
    } catch (e) {}
  }

  function emitCartUpdate() {
    try {
      if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
        window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { source: 'skoon-gwp' });
      }
    } catch (e) {}
  }

  /* ---- Persistent CTA ("Choose your FREE gifts") ---- */
  function ctaButton(owed) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'skoon-gwp-cta';
    btn.setAttribute('data-skoon-gwp-open', 'true');
    btn.textContent = owed > 1 ? 'Choose your ' + owed + ' FREE gifts' : 'Choose your FREE gift';
    btn.addEventListener('click', function () { openModal(); });
    return btn;
  }

  function mountCta(container, owed) {
    if (!container || container.querySelector('[data-skoon-gwp-open]')) return;
    // Drawer: before checkout button. Cart page: before checkout block.
    var anchor = container.querySelector('[name="checkout"], .m-cart__checkout-button, .m-cart__checkout');
    if (anchor) anchor.parentElement.insertBefore(ctaButton(owed), anchor);
    else container.appendChild(ctaButton(owed));
  }

  function ensureCta(earned, have) {
    document.querySelectorAll('[data-skoon-gwp-open]').forEach(function (n) {
      if (n.parentElement) n.parentElement.removeChild(n);
    });
    var owed = (earned || 0) - (have || 0);
    if (!(earned > 0 && owed > 0)) return;
    var drawerFooter = $('#MinimogCartDrawerFooter');
    if (drawerFooter) mountCta(drawerFooter, owed);
    var cartFooter = $('#MinimogCartFooter');
    if (cartFooter) mountCta(cartFooter, owed);
  }

  /* ---- Hooks: detect trigger adds + any cart write ---- */
  function scheduleEvaluate(opts) {
    window.clearTimeout(state.evalTimer);
    state.evalTimer = window.setTimeout(function () { evaluate(opts || {}); }, 350);
  }

  // Variant ids in an add-to-cart request body (JSON or FormData).
  // Used to pair the popup choice with the trigger just added.
  function extractAddedVariantIds(body) {
    var ids = [];
    try {
      if (!body) return ids;
      if (typeof body.get === 'function') {
        try {
          var all = body.getAll ? body.getAll('id') : [body.get('id')];
          (all || []).forEach(function (v) { if (v !== null && v !== undefined && v !== '') ids.push(v); });
        } catch (e) {
          var one = body.get('id');
          if (one !== null && one !== undefined && one !== '') ids.push(one);
        }
        return ids;
      }
      if (typeof body === 'string') {
        var parsed = JSON.parse(body);
        if (parsed) {
          if (parsed.id !== undefined && parsed.id !== null) ids.push(parsed.id);
          if (Array.isArray(parsed.items)) {
            parsed.items.forEach(function (it) {
              if (it && it.id !== undefined && it.id !== null) ids.push(it.id);
            });
          }
        }
      }
    } catch (e) {}
    return ids;
  }

  function isCartWrite(url) {
    return /\/cart(?:\.js|\/(?:add|update|change|clear)(?:\.js)?)(?:\?|#|$)/.test(String(url || ''));
  }
  function isCartAdd(url) {
    return /\/cart\/add(?:\.js)?(?:\?|#|$)/.test(String(url || ''));
  }

  function installFetchHook() {
    if (!window.fetch || window.fetch.__skoonGwp) return;
    var orig = window.fetch.bind(window);
    var wrapped = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (isOurRequest(input, init) || !isCartWrite(url)) return orig(input, init);
      var body = (init && init.body) || null;
      return orig(input, init).then(function (resp) {
        if (resp && resp.ok) {
          if (isCartAdd(url)) {
            // Conservatively prompt on any add; evaluate() confirms via cart.
            // A fresh add always lifts a manual dismiss.
            state.justAddedTrigger = true;
            state.dismissed = false;
            var added = extractAddedVariantIds(body).map(String);
            if (added.length) state.pendingAddedVariants = added;
          }
          scheduleEvaluate(state.justAddedTrigger ? { autoprompt: true } : {});
        }
        return resp;
      });
    };
    wrapped.__skoonGwp = true;
    window.fetch = wrapped;
  }

  // EComposer-era flows POST via XHR; mirror the fetch hook so those adds
  // also autoprompt instead of leaving only the CTA button behind.
  function installXhrHook() {
    try {
      var proto = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
      if (!proto || !proto.open || !proto.send) return;
      if (proto.open.__skoonGwp || proto.send.__skoonGwp) return;
      var origOpen = proto.open;
      var wrappedOpen = function (method, url) {
        try { this.__skoonGwpUrl = String(url || ''); } catch (e) { this.__skoonGwpUrl = ''; }
        return origOpen.apply(this, arguments);
      };
      wrappedOpen.__skoonGwp = true;
      proto.open = wrappedOpen;
      var origSend = proto.send;
      var wrappedSend = function (body) {
        var xhr = this;
        try {
          xhr.addEventListener('load', function () {
            try {
              if (xhr.status < 200 || xhr.status >= 300) return;
              var url = xhr.__skoonGwpUrl || '';
              if (!isCartWrite(url)) return;
              if (isCartAdd(url)) {
                state.justAddedTrigger = true;
                state.dismissed = false;
                var added = extractAddedVariantIds(body).map(String);
                if (added.length) state.pendingAddedVariants = added;
              }
              scheduleEvaluate(state.justAddedTrigger ? { autoprompt: true } : {});
            } catch (e) {}
          });
        } catch (e) {}
        return origSend.apply(xhr, arguments);
      };
      wrappedSend.__skoonGwp = true;
      proto.send = wrappedSend;
    } catch (e) {}
  }

  function bindModalChrome() {
    var modal = modalEl();
    if (!modal || state.ctaBound) return;
    state.ctaBound = true;
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-skoon-gwp-close]')) closeModal(true);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal(true);
    });
  }

  function isCartPage() {
    try {
      return (window.MinimogSettings && window.MinimogSettings.templateName === 'cart') ||
        /\/cart\/?(?:\?|#|$)/.test(window.location.pathname);
    } catch (e) { return false; }
  }

  function onReady() {
    readConfig();
    bindModalChrome();
    installFetchHook();
    installXhrHook();
    loadCatalog().then(function () {
      evaluate({ autoprompt: isCartPage() });
    });
    try {
      if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
        window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, function (data) {
          if (data && data.source === 'skoon-gwp') return;
          scheduleEvaluate({});
        });
        window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, function () {
          state.drawerOpenedAt = Date.now();
          scheduleEvaluate({ autoprompt: true });
        });
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady);
  else onReady();
})();
